import React, { useEffect, useState } from 'react';
import { ShoppingCartIcon, XIcon } from 'lucide-react';
const NAMES = [{
  name: 'Lucía',
  location: 'Rosario'
}, {
  name: 'Carolina',
  location: 'Buenos Aires'
}, {
  name: 'Valentina',
  location: 'Córdoba'
}, {
  name: 'Marcela',
  location: 'Rosario'
}, {
  name: 'Sofía',
  location: 'Mendoza'
}, {
  name: 'Andrea',
  location: 'Mar del Plata'
}, {
  name: 'Laura',
  location: 'La Plata'
}, {
  name: 'María',
  location: 'Tucumán'
}];
const PACKS = ['Pack Base', 'Pack Élite'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    location: '',
    pack: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomPerson = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomPack = PACKS[Math.floor(Math.random() * PACKS.length)];
      setCurrentPurchase({
        name: randomPerson.name,
        location: randomPerson.location,
        pack: randomPack
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Show first popup after 5 seconds
    const initialTimeout = setTimeout(showPopup, 5000);
    // Then show every 30 seconds
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 left-6 z-50 animate-slide-in-left" data-id="element-381">
      <div className="bg-white rounded-lg shadow-2xl border-2 border-[#27AE60] p-4 max-w-sm flex items-start gap-3" data-id="element-382">
        <div className="bg-[#27AE60] p-2 rounded-full flex-shrink-0" data-id="element-383">
          <ShoppingCartIcon className="w-5 h-5 text-white" data-id="element-384" />
        </div>
        <div className="flex-1" data-id="element-385">
          <p className="text-sm font-semibold text-[#2C3E50]" data-id="element-386">
            {currentPurchase.name} de {currentPurchase.location}
          </p>
          <p className="text-xs text-gray-600 mt-1" data-id="element-387">
            acaba de comprar el <strong data-id="element-388">{currentPurchase.pack}</strong>
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-389">Hace unos momentos</p>
        </div>
        <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 flex-shrink-0" data-id="element-390">
          <XIcon className="w-4 h-4" data-id="element-391" />
        </button>
      </div>
    </div>;
}